import { render, staticRenderFns } from "./BannerInfo.vue?vue&type=template&id=0db257fe&scoped=true&"
import script from "./BannerInfo.vue?vue&type=script&lang=js&"
export * from "./BannerInfo.vue?vue&type=script&lang=js&"
import style0 from "./BannerInfo.vue?vue&type=style&index=0&id=0db257fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db257fe",
  null
  
)

export default component.exports